import { ApiDef_Analytics } from '@nu-art/analytics-shared';
import { apiWithBody } from '@nu-art/thunderstorm-frontend/index';
import { Module } from '@nu-art/ts-common';
class ModuleFE_Analytics_Class extends Module {
    _v1 = {};
    init() {
        const apiDef = ApiDef_Analytics(this.config.baseURL);
        this._v1.sendEvent = apiWithBody(apiDef._v1.sendEvent);
        this._v1.updateUser = apiWithBody(apiDef._v1.updateUser);
        this._v1.updateLexicon = apiWithBody(apiDef._v1.updateLexicon);
    }
}
export const ModuleFE_Analytics = new ModuleFE_Analytics_Class();
//# sourceMappingURL=ModuleFE_Analytics.js.map